export const NAMESPACE = 'DRUGS_BY_PHARMACY';